export enum PolynomialForms {
  'Poly-1st',
  'Poly-2nd',
  'Poly-3rd',
  'Poly-4th',
  'Poly-5th',
  'Poly-6th'
}
